import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { initConsent, setConsent, getConsent } from "../lib/analytics";

// Bannière de consentement cookies (analytics GA4 / Meta) — RGPD.
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initConsent();
    if (getConsent() === null) setVisible(true);
  }, []);

  const choose = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          role="dialog"
          aria-label="Gestion des cookies"
          data-testid="cookie-banner"
        >
          <div className="cookie-banner__inner">
            <p className="cookie-banner__text">
              Nous utilisons des cookies de mesure d'audience (Google Analytics, Meta) pour
              améliorer cette page. Tu peux accepter ou refuser. Voir la{" "}
              <a href="#confidentialite" className="cookie-banner__link">
                politique de confidentialité
              </a>
              .
            </p>
            <div className="cookie-banner__actions">
              <button
                className="btn btn--ghost cookie-banner__refuse"
                onClick={() => choose(false)}
                data-testid="cookie-refuse"
              >
                Refuser
              </button>
              <button
                className="btn btn--primary"
                onClick={() => choose(true)}
                data-testid="cookie-accept"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
